import { CommsStore } from "@store/comms";
import { ActionReducer, Action } from "@ngrx/store"

export const commsReducer: ActionReducer<CommsStore> = (state: CommsStore = new CommsStore(), action: Action) => {

  const s = CommsStore.clone(state)

  switch(action.type) {
    case POPULATE_TEMPLATES:
      s.templates = action.payload
      return s

    case POPULATE_COMM_SENDS:
      s.commSends = action.payload
      return s

    case POPULATE_COMM_RECEIPTS:
      s.commReceipts = action.payload
      return s

    case POPULATE_EMAIL_PREVIEW:
      s.emailPreview = action.payload
      return s

    case POPULATE_NUMBER_OF_RECIPIENTS:
      s.numberOfRecipients = action.payload
      return s

    default:
      return s
  }

}

export const FETCH_TEMPLATES = "FETCH_TEMPLATES"
export const FETCH_TEMPLATES_FAILURE = "FETCH_TEMPLATES_FAILURE"
export const POPULATE_TEMPLATES = "POPULATE_TEMPLATES"
export const RELOAD_EMAIL_TEMPLATES = "RELOAD_EMAIL_TEMPLATES"
export const RELOAD_EMAIL_TEMPLATES_SUCCESS = "RELOAD_EMAIL_TEMPLATES_SUCCESS"
export const RELOAD_EMAIL_TEMPLATES_FAILURE = "RELOAD_EMAIL_TEMPLATES_FAILURE"
export const SEND_COMM = "SEND_COMM"
export const SENT_COMM = "SENT_COMM"
export const SEND_COMM_FAILURE = "SENT_COMM_FAILURE"
export const FETCH_COMM_SENDS = "FETCH_EMAIL_SENDS"
export const POPULATE_COMM_SENDS = "POPULATE_COMM_SENDS"
export const FETCH_COMM_SENDS_FAILURE = "FETCH_COMM_SENDS_FAILURE"
export const FETCH_COMM_RECEIPTS = "FETCH_COMM_RECEIPTS"
export const POPULATE_COMM_RECEIPTS = "POPULATE_COMM_RECEIPTS"
export const FETCH_COMM_RECEIPTS_FAILURE = "FETCH_COMM_RECEIPTS_FAILURE"
export const FETCH_EMAIL_PREVIEW = "FETCH_EMAIL_PREVIEW"
export const POPULATE_EMAIL_PREVIEW = "POPULATE_EMAIL_PREVIEW"
export const FETCH_EMAIL_PREVIEW_FAILURE = "FETCH_EMAIL_PREVIEW_FAILURE"
export const GET_NUMBER_OF_RECIPIENTS = "GET_NUMBER_OF_RECIPIENTS"
export const POPULATE_NUMBER_OF_RECIPIENTS = "POPULATE_NUMBER_OF_RECIPIENTS"
export const GET_NUMBER_OF_RECIPIENTS_FAILURE = "GET_NUMBER_OF_RECIPIENTS_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/comms.ts